import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.popularPlace;

export const popularPlaceSelectors = {
  popularPlaces: createSelector(
    selector,
    (popularPlace) => popularPlace.popularPlaces
  ),
};
